import popupContainerPositioning from './popupContainerPositioning'

const plugins = {}
plugins['wysiwyg.viewer.components.PopupContainer'] = popupContainerPositioning

export default plugins
